function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 27,
  r: 24,
  fill: "#FFD13C"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8 33.16V38H16.56V33.16H22.24V21.04C21.92 21.44 21.3733 21.8667 20.6 22.32C19.8533 22.7733 19.0267 23.16 18.12 23.48C17.24 23.8 16.4533 23.96 15.76 23.96V18.96C16.24 18.96 16.8133 18.8133 17.48 18.52C18.1733 18.2 18.8533 17.8267 19.52 17.4C20.2133 16.9733 20.8 16.56 21.28 16.16C21.7867 15.7333 22.1067 15.4 22.24 15.16H27.72V33.16H32.8Z",
  fill: "white"
});
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.a7dabe6585bdf642d9d542e254892299.svg";
export { ForwardRef as ReactComponent };